import { createApi } from "@reduxjs/toolkit/query/react";
import { reducerPaths } from "../../app/reducerPaths";
import { baseQueryWithAuth } from "../methods/baseQueryWithAuth";

export const buyNowApi = createApi({
  reducerPath: reducerPaths.buyNowApi, // Unique key in Redux store
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getBuyNowVehicles: builder.query({
      query: ({ method, params }) => ({
        url: `/myGarage/Seller/BuyNow`,
        method: "GET",
        params: params || {},
      }),
    }),
    getBuyNowTimeoutDetails: builder.query({
      query: ({ Vehicle_Id }) => {
        return {
          method: "GET",
          url: `/buynowtimeoutdetails/${Vehicle_Id}`,
        }
      }
    })
  }),
});

export const {
  useLazyGetBuyNowVehiclesQuery,
  useLazyGetBuyNowTimeoutDetailsQuery,
} = buyNowApi;
